// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"792":"main","917":"error.pages"}[chunkId] + ".css";
};